import { NavigationItem } from './navigation-item';

export class NavigationItems {
  /**
   * Constructor
   *
   * @param defaultItems
   * @param moduleItems
   */
  public constructor(
    public defaultItems: NavigationItem[] = [],
    public moduleItems: NavigationItem[] = [],
  ) { }
}
